import { ActionType } from '../../constants/ActionTypes'

export default function usersReducer(state = {}, action) {
    switch (action.type) {
        // Get Users
        case ActionType.GET_ALL_USERS_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.GET_ALL_USERS_SUCCESS:
            return {
                ...state,
                inProcess: false,
                affUsers: action.payload.Data
            }

        case ActionType.GET_ALL_USERS_FAILURE:
            return {
                ...state,
                inProcess: false,
                affUsers: action.payload.Data,
            };

        // Get User
        case ActionType.GET_USER_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.GET_USER_SUCCESS:
            return {
                ...state,
                inProcess: false,
                affUser: action.payload.Data
            }

        case ActionType.GET_USER_FAILURE:
            return {
                ...state,
                inProcess: false,
                affUser: action.payload.Data,
            };

        // Add User
        case ActionType.ADD_USER_BEGIN:
            return {
                ...state,
                inProcess: true
            };

        case ActionType.ADD_USER_SUCCESS:
            return {
                ...state,
                ...action.payload.user,
                inProcess: false
            };

        case ActionType.ADD_USER_FAILURE:
            return {
                ...state,
                inProcess: false,
                user: {
                    ...state.user,
                    error: action.payload
                }
            };

        // Get User Types
        case ActionType.GET_USER_TYPES_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.GET_USER_TYPES_SUCCESS:
            return {
                ...state,
                inProcess: false,
                data: action.payload.Data
            }
        case ActionType.GET_USER_TYPES_FAILURE:
            return {
                ...state,
                inProcess: true,
                data: action.payload.Data
            }

        // Get User Allowed Partners
        case ActionType.GET_USER_ALLOWED_PARTNERS_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.GET_USER_ALLOWED_PARTNERS_SUCCESS:
            return {
                ...state,
                inProcess: false,
                allowedPartners: action.payload.Data
            }

        case ActionType.GET_USER_ALLOWED_PARTNERS_FAILURE:
            return {
                ...state,
                inProcess: true,
                allowedPartners: action.payload.Data
            }

        // Edit User
        case ActionType.EDIT_USER_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.EDIT_USER_SUCCESS:
            return {
                ...state,
                inProcess: false,
                data: action.payload.Data
            }

        case ActionType.EDIT_USER_ERROR:
            return {
                ...state,
                inProcess: true,
                data: action.payload.Data
            }
        // Delete User
        case ActionType.DELETE_USER_BEGIN:
            return {
                ...state,
                inProcess: true
            };

        case ActionType.DELETE_USER_SUCCESS:
            return {
                ...state,
                inProcess: false
            }

        case ActionType.DELETE_USER_ERROR:
            return {
                ...state,
                inProcess: true
            }
        default:
            return state;
    }

}




// WEBPACK FOOTER //
// ./src/reducers/mainAffilate/UsersReducer.js